import React, { useState, useEffect } from "react";
import Select from "react-select";
import Switch from "react-switch";
import { Button as AntButton, Checkbox } from "antd";
import * as tConst from "../../../common/Constants";
import { StepForwardOutlined, StepBackwardOutlined, SettingOutlined, LogoutOutlined } from '@ant-design/icons';
import { DatePicker, InputNumber, Divider, Dropdown } from 'antd';
import LegendDialog from "../../LegendDialog";

const ToolBarAdo = ({ filterMinPlanningPri, filterMaxPlanningPri, ...props }) => {
  const [showSettings, setShowSettings] = useState(false);
  const [localChartHeight, setLocalChartHeight] = useState(
    parseInt(localStorage.getItem('chartHeight')) || 300
  );

  const [showCommitedScope, setShowCommitedScope] = useState(filterMinPlanningPri <= 0 && filterMaxPlanningPri >= 999);
  const [showStretchScope, setShowStretchScope] = useState(filterMinPlanningPri <= 1000 && filterMaxPlanningPri >= 1499);
  const [showOtherScope, setShowOtherScope] = useState(filterMinPlanningPri <= 1500  && filterMaxPlanningPri === Number.MAX_SAFE_INTEGER);

  // Effect to sync localStorage with props
  useEffect(() => {
    if (props.chartHeight) {
      localStorage.setItem('chartHeight', props.chartHeight);
      setLocalChartHeight(props.chartHeight);
    }
  }, [props.chartHeight]);


  function setFilterPlanningPri(_showCommitedScope, _showStretchScope, _showOtherScope){
    let min = Number.MIN_SAFE_INTEGER;
    let max = Number.MAX_SAFE_INTEGER;

    if (_showCommitedScope && !_showStretchScope && !_showOtherScope) {
      min = 0;
      max = 999;
    } else if (!_showCommitedScope && _showStretchScope && !_showOtherScope) {
      min = 1000;
      max = 1499;
    } else if (_showCommitedScope && _showStretchScope && !_showOtherScope) {
      min = 0;
      max = 1499;
    } else if (!_showCommitedScope && !_showStretchScope && _showOtherScope) {
      min = 1500;
      max = Number.MAX_SAFE_INTEGER;
    } else if (!_showCommitedScope && _showStretchScope && _showOtherScope) {
      min = 1000;
      max = Number.MAX_SAFE_INTEGER;
    } else if (_showCommitedScope && _showStretchScope && _showOtherScope) {
      min = Number.MIN_SAFE_INTEGER;
      max = Number.MAX_SAFE_INTEGER;
    }

    props.setFilterMinPlanningPri(min);
    props.setFilterMaxPlanningPri(max);

  }
  // Create settings menu content
  const settingsContent = (
    <div style={{
      backgroundColor: 'white',
      padding: '16px',
      borderRadius: '4px',
      width: '300px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
    }}>
      <div style={{ marginBottom: '16px' }}>
        <label style={{ display: 'block', marginBottom: '8px' }}>
          Chart Height:
        </label>
        <InputNumber
          min={300}
          max={3600}
          value={localChartHeight}
          onChange={props.onHandleChartHeightChange}
          step={50}
          style={{ width: '100%' }}
        />
      </div>

      <Divider style={{ margin: '12px 0' }} />
      
      <div style={{ marginBottom: '16px' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <label>Use Menu</label>
          <Switch
            onChange={(() => {
              props.setOpenOnClickStatus(!props.openOnClickStatus);
            })}
            checked={!props.openOnClickStatus}
          />
        </div>
      </div>
      <Divider style={{ margin: '12px 0' }} />
      <div style={{ marginBottom: '16px' }}>
        <div >
          <div>
            <label>Filter</label>
            <br/>
          </div>
            <Checkbox
              checked={showCommitedScope}
            onChange={(e) => {
              setShowCommitedScope(e.target.checked);
              setFilterPlanningPri(e.target.checked, showStretchScope, showOtherScope);
            }}
          >
            Committed scope (0-999)
          </Checkbox> <br/>
          <Checkbox
            checked={showStretchScope}
            onChange={(e) => {
              setShowStretchScope(e.target.checked);
              setFilterPlanningPri(showCommitedScope, e.target.checked, showOtherScope);
            }}
          >
            Stretch scope (1000-1499)
          </Checkbox> <br/>
          <Checkbox
            checked={showOtherScope}
            onChange={(e) => {
              setShowOtherScope(e.target.checked);
              setFilterPlanningPri(showCommitedScope, showStretchScope, e.target.checked);
            }}
          >
            Other scope (1500+)
          </Checkbox> <br/>
          <Checkbox
            checked={showCommitedScope && showStretchScope && showOtherScope}
            onChange={(e) => {
              setShowCommitedScope(e.target.checked);
              setShowStretchScope(e.target.checked);
              setShowOtherScope(e.target.checked);
              setFilterPlanningPri(e.target.checked, e.target.checked, e.target.checked);
            }}
          >
            All scopes
          </Checkbox> <br/>
        </div>
      </div>

      <Divider style={{ margin: '12px 0' }} />
      <LegendDialog />
      <Divider style={{ margin: '12px 0' }} />

      <AntButton 
        type="default"
        icon={<LogoutOutlined />}
        onClick={props.onLogout}
      >
        Logout
      </AntButton>

      <AntButton
        type="primary"
        onClick={() => setShowSettings(false)} 
        style={{ float: 'right', width: 'auto' }}
      >
        Close
      </AntButton>
    </div>
  );

  return (
    <>
      <table width="100%">
        <tbody>
          <tr>
            <td colSpan="2">
              {/* Col 1 */}
              {" "}
              <label>Project</label>
            </td>
            <td colSpan="3">
              {/* Col 3 */}
              {props.showTeamsFilter && <label color="#f2feea">Filter by Initiative</label>}
            </td>
            <td >
              {/* Col 6 */}
              <label>Select View</label>
            </td>
            <td color="#f2feea">
              {/* Col 7 */}
              <label>Highlight Assignee</label>
            </td>
            <td>
              {/* Col 8 */}
              {props.showTeamsFilter && <label>Highlight Team</label>}
            </td>
            <td>
              {/* Col 9 */}
              <label>Filter quarter</label>
            </td>
            <td>{/* Col 10 */}</td>
            <td>{/* Col 11 */}</td>
            <td>{/* Col 12 */}</td>
            <td> {/* Col 13 */}
              <Dropdown 
                menu={{ items: [{ key: 'settings', label: settingsContent }] }}
                trigger={['click']}
                open={showSettings}
                onOpenChange={(visible) => setShowSettings(visible)}
                placement="bottomRight"
              >
                <AntButton
                  type="link"
                  icon={<SettingOutlined />}
                  style={{ color: showSettings ? '#1890ff' : undefined }}
                >
                  Settings
                </AntButton>
              </Dropdown>
            </td>
          </tr>
          <tr>
            {/* Row 2 */}
            <td width="17%">

              <Select
                className="basic-single"
                classNamePrefix="select"
                options={props.projects}

                style={{ width: "40px" }}
                name="projectId"
                isSearchable={true}
                value={props.projects ? props.projects.filter((filt) => {
                  return filt.value === props.selectedProject
                }) : null}
                onChange={props.projectOnChange}
              />

            </td>
            <td width="4%">
              <button onClick={() => {
                props.onHideProject(props.selectedProject)
              }}>Hide</button>
            </td>
            <td width="1%">
              {props.showTeamsFilter &&
                <>
                  <AntButton
                    color="primary"
                    icon={<StepBackwardOutlined />}
                    variant="outline"
                    size="sm"
                    onClick={() => {
                      const index = props.initiativeList.findIndex((item) => item.value === props.selectedInitiative);
                      const previousIndex = (index - 1) < 0 ? props.initiativeList.length - 1 : (index - 1);
                      const _newIntiative = props.initiativeList[previousIndex];
                      props.initiaitveOnChange(_newIntiative)
                    }}
                  />
                </>
              }
            </td>
            <td width="13%">
              {props.showTeamsFilter &&
                <>
                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    options={props.initiativeList}

                    style={{ width: "40px" }}
                    name=""
                    value={props.initiativeList.filter((filt) => {
                      return filt.value === props.selectedInitiative
                    }
                    )}
                    isSearchable={true}
                    onChange={props.initiaitveOnChange}
                  />
                </>
              }

            </td>
            <td width="2%">
              {props.showTeamsFilter &&
                <>
                  <AntButton
                    color="primary"
                    icon={<StepForwardOutlined />}
                    variant="outline"
                    size="sm"
                    onClick={() => {
                      const index = props.initiativeList.findIndex((item) => item.value === props.selectedInitiative);
                      const nextIndex = (index + 1) % props.initiativeList.length;
                      const _newIntiative = props.initiativeList[nextIndex];
                      props.initiaitveOnChange(_newIntiative)
                    }}
                  />
                </>
              }
            </td>
            <td width="10%">
              <Select
                className="basic-single"
                classNamePrefix="select"
                options={tConst.VIEW_SELECT_OPTION}

                style={{ width: "40px" }}
                name=""
                isSearchable={true}
                value={tConst.VIEW_SELECT_OPTION.filter((filt) => {
                  return filt.value === props.viewId
                }
                )}
                onChange={props.viewOnChange}
              />
            </td>
            {/* Assignee */}
            <td width="10%">
              <Select
                className="basic-single"
                classNamePrefix="select"
                options={props.assigneeList}

                style={{ width: "40px" }}
                name=""
                value={props.assigneeList.filter((filt) => {
                  return filt.value === props.assigneeId
                }
                )}
                isSearchable={true}
                onChange={props.assigneeOnChange}
              />

              {/*


                        */}
            </td>
            {/* Initiative */}
            <td width="10%">
              {props.showTeamsFilter && <Select
                className="basic-single"
                classNamePrefix="select"
                options={tConst.VIEW_SELECT_TEAMS_OPTION}

                style={{ width: "40px" }}
                name=""
                value={tConst.VIEW_SELECT_TEAMS_OPTION.filter((filt) => {
                  return filt.value === props.teamsId
                }
                )}
                isSearchable={true}
                onChange={props.teamsOnChange}
              />
              }</td>
            <td width="10%">
              <DatePicker
                picker="quarter"
                value={props.quarterFilter}
                onChange={(date) => {                
                  props.setQuarterFilter(date);
                }}
              />

            </td>
            <td width="6%">
              {
                <button onClick={props.onRefreshClick}>Refresh</button>
              }
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );
};

export default ToolBarAdo;